goog.module('yext.developerapps.wazeadssyncing.init');
goog.module.declareLegacyNamespace();

const WazeConfiguration = goog.require('yext.developerapps.wazeadssyncing.WazeConfiguration');
const WazeSyncNow = goog.require('yext.developerapps.wazeadssyncing.WazeSyncNow');

$(document).ready(function() {
  var initIdentifier = $('.js-wazeadssyncing-init').data('jsinit');
  switch (initIdentifier) {
    case 'configuration':
      new WazeConfiguration();
      new WazeSyncNow();
      break;
  }
});

